'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { BadgeCounterVariant, badgeCounterStyles } from './BadgeCounter.styles'

export type { BadgeCounterVariant }

export interface BadgeCounterIProps {
  count?: number
  maxCount?: number
  variant?: BadgeCounterVariant
  colorScheme?: ColorScheme
  className?: string
}

export type BadgeCounterProps = BadgeCounterIProps

export const BadgeCounter = ({
  count,
  maxCount = 99,
  variant = 'button',
  colorScheme = 'dark',
  className,
}: BadgeCounterIProps) => {
  if (variant !== 'notification-dot' && count == null) return null

  const displayCount =
    count != null && count > maxCount ? `${maxCount}+` : count?.toLocaleString()

  return (
    <Box
      as='span'
      className={className}
      {...badgeCounterStyles(variant, colorScheme)}
    >
      {variant !== 'notification-dot' ? displayCount : null}
    </Box>
  )
}
